import { useEffect, useState } from "react";

const DEFAULT_INTERACTION_DELAY_MS = 5000;

/**
 * Counts down a short delay from mount so a modal can block dismissing or acting
 * until users have had time to read it. The countdown resets on each mount, so
 * render the consuming component only while the modal is open.
 */
const useModalInteractionDelay = (delayMs = DEFAULT_INTERACTION_DELAY_MS) => {
  const [secondsRemaining, setSecondsRemaining] = useState(() =>
    Math.ceil(delayMs / 1000)
  );

  useEffect(() => {
    const startedAt = Date.now();

    const intervalId = window.setInterval(() => {
      const elapsedMs = Date.now() - startedAt;
      const remaining = Math.max(0, Math.ceil((delayMs - elapsedMs) / 1000));
      setSecondsRemaining(remaining);

      if (remaining === 0) {
        window.clearInterval(intervalId);
      }
    }, 100);

    return () => {
      window.clearInterval(intervalId);
    };
  }, [delayMs]);

  return {
    isInteractionDelayed: secondsRemaining > 0,
    secondsRemaining,
  };
};

export { useModalInteractionDelay, DEFAULT_INTERACTION_DELAY_MS };
